import React from 'react';
import { Avatar } from '@mui/joy';
import { Box } from '@mui/material';
import { Check } from '@mui/icons-material';
import { useThemeContext } from '../../../context/ThemeContext';

const Profile = 'assets/images/Mask group (11).png';
const Star = 'assets/images/icons/Star-8.png';


const BiddersCard = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '146px',
        height: '146px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >

      <Avatar
        src={Profile}
        alt="User"
        sx={{
          width: '132.77px',
          height: '132.77px',
        }}
      />

   
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '146px',
          height: '146px',
          borderRadius: '50%',
          border: '2px solid #2E2E2E',
          boxSizing: 'border-box',
          pointerEvents: 'none',
        }}
      />

    
      <Box
        sx={{
          position: 'absolute',
          top: '20px',
          right: '-16px',
          backgroundImage: `url(${Star})`, // Corrected image reference
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '50%',
          width: '35px',
          height: '35px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: 'translate(-50%, -50%)', // Offset to center it

        }}
      >

        <Check
          sx={{
            fontSize: '15px',

            width: "15px",
            height: "15px",
            color: '#FFFFFF',

          }}
        />
      </Box>

    </Box>
  );
};

export const CraftsCard = () => {
  const { isSM, isMd, isMD, isLg } = useThemeContext()
  return (
    <Box
      sx={{
        position: 'relative',

        width: isSM ? '42.59px' : isMD ? '146px' : '146px',
        height: isSM ? '42.59px' : isMD ? '146px' : '146px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        margin:'0 auto'

      }}
    >

      <Avatar
        src={Profile}
        alt="User"
        sx={{
          width: isSM ? '38.73px' : isMD ? '132.77px' : isMd ? '132.77px' : isLg ? '132.77px' : '132.77px',
          height: isSM ? '38.73px' : isMD ? '132.77px' : isMd ? '132.77px' : isLg ? '132.77px' : '132.77px',
          margin: '0 auto'
        }}
      />

      <Box
        sx={{
          position: 'absolute',
       
          width: isSM ? '42.59px' : isMD ? '146px' : '146px',
          height: isSM ? '42.59px' : isMD ? '146px' : '146px',
          borderRadius: '50%',
          border: isSM ? '0.5px solid #2E2E2E' : isMD ? '1px solid #2E2E2E' : isMd ? '2px solid #2E2E2E' : '2px solid #2E2E2E',
          boxSizing: 'border-box',
    
       
        }}
      />


    </Box>
  );
};

export default BiddersCard;
